import React, { createContext, useContext, useMemo, useState } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  function showToast({ title, message, actionLabel, onAction, duration = 4500, type = 'info' }) {
    const id = Math.random().toString(36).slice(2);
    const toast = { id, title, message, actionLabel, onAction, type };
    setToasts((prev) => [...prev, toast]);
    if (duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    }
  }

  function dismiss(id) {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }

  const value = useMemo(() => ({ showToast }), []);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed bottom-5 left-5 z-[100] space-y-3" dir="rtl">
        {toasts.map((t) => (
          <div
            key={t.id}
            className="w-[320px] max-w-[90vw] rounded-2xl shadow-2xl border border-gray-200 bg-white p-4"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                {t.title && <div className="text-sm font-bold text-gray-900 mb-1">{t.title}</div>}
                {t.message && <div className="text-xs text-gray-600 leading-relaxed">{t.message}</div>}
              </div>
              <button
                onClick={() => dismiss(t.id)}
                className="text-gray-400 hover:text-gray-700 text-sm"
                aria-label="close"
              >
                ✕
              </button>
            </div>
            {t.actionLabel && typeof t.onAction === 'function' && (
              <button
                onClick={() => {
                  dismiss(t.id);
                  t.onAction();
                }}
                className="mt-3 inline-flex items-center justify-center px-3 py-1.5 rounded-full text-xs font-semibold bg-[#005bbb] text-white hover:bg-[#004a99] transition"
              >
                {t.actionLabel}
              </button>
            )}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
